import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  toggle(event) {
    if (event.target.closest(".actions-menu")) return

    const isHidden = this.contentTargets[0]?.hidden
    this.contentTargets.forEach(el => el.hidden = !isHidden)
    this.iconTarget.style.transform = isHidden ? "rotate(0deg)" : "rotate(-90deg)"
  }
}
